import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { enableParkingService } from '../../api/parking-service.ts';

export default function useEnableParkingService(): UseMutationResult<
  Awaited<ReturnType<typeof enableParkingService>>,
  Error,
  string
> {
  return useMutation({
    mutationFn: (serviceId: string) => enableParkingService(serviceId),
  });
}
